<template>
  <div class="relative w-full">
    <div
      :class="{ 'opacity-100': loading, 'opacity-0': !loading }"
      class="absolute inset-0 flex items-center justify-center transition-opacity duration-300 z-20 pointer-events-none"
    >
      <LoaderSpinner class="w-6 h-6" />
    </div>
    <span
      :class="{ 'opacity-0': loading, 'opacity-100': !loading }"
      class="transition-opacity duration-300"
    >
      <slot></slot>
    </span>
  </div>
</template>

<script>
import LoaderSpinner from "./LoaderSpinner.vue";
export default {
  names: "ButtonLoading",
  components: { LoaderSpinner },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
